import React, { useState } from 'react';
import { Dropdown, message } from 'antd';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { clearUserData } from '@/reducers/users';
import { toggleLoginModal } from '@/reducers/login-pop';
import { maskAccount } from '@/libs/utils/util';
import logged from '@/assets/icons/logged.png';
import down from '@/assets/icons/down.png';
import styles from './UserDropdown.module.scss';

const UserDropdown = ({ userData, isSXNU }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teachingResearchState = {
    account: userData?.account,
    company_name: userData?.company_name,
    authInfo: userData?.authInfo,
    quotaInfo: userData?.quotaInfo,
  };

  const handleOutSign = () => {
    dispatch(clearUserData());
    dispatch(toggleLoginModal(false));
    navigate(isSXNU ? '/sxnu' : '/');
    message.info('退出登录');
  };

  if (!userData) return null;

  const handleOpenTeachingResearch = () => {
    localStorage.setItem(
      'teachingResearchEntryUserData',
      JSON.stringify(teachingResearchState),
    );
  };

  // Menu Items Logic
  const getMenuItems = () => {
    const items = [];

    // Account Info Item (First Item)
    if (userData?.authInfo?.vip !== 1) {
      items.push({
        label: (
          <div className={styles.dropdownItemClass}>
            {userData?.authInfo?.vip == 0 ? (
              <a
                className={styles.accountAuthLinkClass}
                href="https://www.zmrobo.com/contact"
                target="_blank"
                rel="noreferrer"
              >
                <div
                  className={styles.accountAuthClass}
                  style={{ height: '40px' }}
                >
                  <span style={{ fontSize: '14px' }}>去授权</span>
                </div>
              </a>
            ) : userData?.authInfo?.vip == 2 ? (
              <div
                className={styles.accountAuthClass}
                style={{
                  '--fs-color': '#805328',
                  '--bg-color': '#fedebf',
                }}
              >
                <span style={{ fontSize: '16px' }}>
                  {userData?.authInfo?.account_type}
                </span>
                <span>有效期：{userData?.authInfo?.left_valid_time}天</span>
              </div>
            ) : null}
          </div>
        ),
        disabled: userData?.authInfo?.vip == 2,
        key: 'accountType',
        style: { cursor: 'default' },
      });

      // Teaching Research System Button
      items.push({
        label: (
          <NavLink
            className={styles.researchBtnClass}
            // to="/teaching-research"
            to="/teachingBlock"
            state={{ userData: teachingResearchState }}
            target="_blank"
            onClick={handleOpenTeachingResearch}
          >
            教研系统
          </NavLink>
        ),
        key: 'teachingSystem',
      });
    }

    // Logout Item
    items.push({
      label: (
        <div
          className={classNames(
            styles.dropdownItemClass,
            styles.loginOutClass,
            {
              [styles.singleLoginOut]: !(
                userData?.authInfo?.company_name || userData?.company_auth == 1
              ),
            },
          )}
          onClick={handleOutSign}
        >
          退出登录
        </div>
      ),
      key: 'loginOut',
    });

    return items;
  };

  return (
    <Dropdown
      open={openDropdown}
      onOpenChange={setOpenDropdown}
      overlayClassName={classNames(styles.logOutClass, {
        [styles.singleItemDropdown]: userData?.authInfo?.vip === 1,
      })}
      menu={{
        items: getMenuItems(),
      }}
      trigger={['click']}
      placement="bottom"
      arrow={{ pointAtCenter: true }}
    >
      <div className={classNames(styles.loginOutLogoClass)}>
        <div className={styles.userLogo}>
          <img src={logged} width={'100%'} draggable={false} alt="User Logo" />
          {userData?.authInfo?.vip != 0 ? (
            <span
              className={styles.tagClass}
              style={{
                '--fs-color': '#805328',
                '--bg-color': '#fedebf',
              }}
            >
              校
            </span>
          ) : null}
        </div>
        <div className={styles.expireClass}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {maskAccount(userData?.account)}
            <img
              className={classNames({
                [styles.openLoginOutMenuClass]: openDropdown,
              })}
              src={down}
              width={11}
              draggable={false}
              style={{ marginLeft: '6px' }}
              alt="Down Arrow"
            />
          </div>
          {userData?.company_auth || userData?.authInfo?.vip === 1 ? (
            <div className={styles.toAuthClass}>
              {userData?.authInfo?.vip === 1 ? (
                <span style={{ color: '#ADFF5B' }}>学生</span>
              ) : (
                userData?.company_name
              )}
            </div>
          ) : null}
        </div>
      </div>
    </Dropdown>
  );
};

export default UserDropdown;
